import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { APIConstants } from '../../../_config/restapis';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { APILoginService } from '../_services/login/API-login';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';




@Injectable()
export class LoginActivateService implements CanActivate {
  //expired: any;
  constructor(private authService: APILoginService, private router: Router) {
  
  }
  data:{
    roles: ['TATA', 'RTM', 'PE','Subscriber'],
  
 }
  canActivate(
    next: ActivatedRouteSnapshot,
   // route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean>|Promise<boolean>|boolean {
    let role = localStorage.getItem('currentUser');
    console.log("role print here",role)
    if (localStorage.getItem('currentUser')) {
      if(next.data[0] == role){
  
         //setTimeout(function(){ localStorage.removeItem('currentUser'); },600000)
        
        return true;
      } 
    }
    else{
      this.router.navigate(['/'], { queryParams: { returnUrl: state.url }});
      return false;
    }
  }
}